import { CheckoutUpdateParameters } from "common/Messages";
import { CheckoutParams, CommonParams } from "common/types";
import { InstallmentPlan } from "univapay-node";

/**
 * Compute amount parameter to translate the legacy usage of the widget to the latest convention
 */
export const computeAmountParams = (params: Partial<CommonParams>) => {
    const {
        subscriptionPlan,
        installmentPlan,
        subscriptionInitialAmount,
        amount,
        installmentQty,
        subscriptionQty,
    } = params;

    const numberSubscriptionInitialAmount = Number(subscriptionInitialAmount || 0);

    // In the case of a limited subscription, we deduct the initial amount here
    // so that we can validate (using our AJV schema) that initial amount < total amount (amount)
    // After the validation takes place we add it back
    const formattedAmount = subscriptionPlan ? amount - numberSubscriptionInitialAmount : amount;

    const formattedQty =
        subscriptionPlan && subscriptionQty
            ? {
                  subscriptionQty:
                      subscriptionPlan === InstallmentPlan.FIXED_CYCLES && numberSubscriptionInitialAmount
                          ? subscriptionQty - 1
                          : subscriptionQty,
              }
            : installmentPlan && installmentQty
            ? { installmentQty }
            : {};

    return {
        amount: formattedAmount,
        subscriptionInitialAmount,
        ...formattedQty,
    };
};

export const updateParamsToCheckoutParams = (overrides: CheckoutUpdateParameters): Partial<CheckoutParams> => ({
    tokenType: overrides.tokenType,
    subscriptionPeriod: overrides.subscriptionPeriod,
    checkout: overrides.checkout,

    // Subscription data
    subscriptionInitialAmount: overrides.subscriptionInitialAmount,
    subscriptionStart: overrides.subscriptionStart,
    subscriptionStartIn: overrides.subscriptionStartIn,
    subscriptionStartDayOfMonth: overrides.subscriptionStartDayOfMonth,
    subscriptionPlan: overrides.subscriptionPlan,
    subscriptionQty: overrides.subscriptionQty,
    installmentPlan: overrides.installmentPlan,
    installmentQty: overrides.installmentQty,
    subscriptionPreserveEndOfMonth: overrides.subscriptionPreserveEndOfMonth,
    subscriptionRetryInterval: overrides.subscriptionRetryInterval,

    // Payment data
    amount: overrides.amount,
    currency: overrides.currency,
    capture: overrides.capture,
    captureAt: overrides.captureAt,
    captureIn: overrides.captureIn,
    captureDayOfMonth: overrides.captureDayOfMonth,

    // UX data
    showCvv: overrides.showCvv,
    hideRecurringCheckbox: overrides.hideRecurringCheckbox,
    hidePrivacyLink: overrides.hidePrivacyLink,
    paymentMethods: overrides.paymentMethods,
    allowCardInstallments: overrides.allowCardInstallments,
    cardInstallmentOptions: overrides.cardInstallmentOptions,

    metadata: overrides.metadata,
    customerName: overrides.name,
    customerNameKana: overrides.nameKana,
    email: overrides.email,
    phoneNumber: overrides.phoneNumber?.localNumber
        ? `${overrides.phoneNumber.countryCode || "81"}${overrides.phoneNumber.localNumber}`
        : undefined,
    shippingAddressLine1: overrides.address?.line1,
    shippingAddressLine2: overrides.address?.line2,
    shippingAddressCity: overrides.address?.city,
    shippingAddressState: overrides.address?.state,
    shippingAddressZip: overrides.address?.zip,
    shippingAddressCountryCode: overrides.address?.countryCode,
});
